import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { FormOfPaymentSort, FormOfPaymentUpdateSortSequence } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentReferenceService } from "src/app/core/services/system-services/form-of-payment-reference.service";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentSortService {

    private _formOfPayments$ = new BehaviorSubject<FormOfPaymentSort[]>([])
    private _callSort$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()
    private _updateSort$ = new Subject()
    private _formOfPaymentTypeCode: string;
    private _formOfPaymentTypeName$= new BehaviorSubject<string>(null)

    get formOfPayments$() {
        return this._formOfPayments$.asObservable()
    }
    get callSort$() {
        return this._callSort$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }
    get updateSort$() {
        return this._updateSort$.asObservable()
    }
    get formOfPaymentTypeName$() {
        return this._formOfPaymentTypeName$.asObservable()
    }

    constructor(private formOfPaymentReference: FormOfPaymentReferenceService
    ) {
    }

    getFormOfPaymentsSort(): Observable<FormOfPaymentSort[]> {
        if (this._formOfPaymentTypeCode) {
            return this.formOfPaymentReference.getSort(this._formOfPaymentTypeCode)
                .pipe(
                    tap(response => this._formOfPayments$.next(response))
                )
        }
    }

    updateSortSequence(items: FormOfPaymentUpdateSortSequence[]): Observable<never> {
        return this.formOfPaymentReference.updateSortSequence(items)
    }

    clearSort() {
        this._formOfPayments$.next([])
    }
    callSort(formOfPaymentTypeCode: string, formOfPaymentTypeName: string) {
        this._formOfPaymentTypeCode = formOfPaymentTypeCode;
        this._formOfPaymentTypeName$.next(formOfPaymentTypeName);
        this._callSort$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }
    updateSort() {
        this._updateSort$.next()
    }
}
